<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('promotion.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('promotion.pageTitle'),
          active: true,
        },
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker v-model="dateRange" :ranges="{
              'This Month': [moment().startOf('M'), moment().endOf('month')]
            }" @change="fetchData()" class="ts-w-64" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY" />
          </div>
          <div class="ts-justify-end">
            <Tooltip :content="$t('promotion.search')" placement="top" transfer :max-width="width">
              <Input search v-model="search" :placeholder="$t('promotion.search')" :style="width"
                @on-focus="() => (width = 'width: 500px')" @on-blur="() => (width = 'width: 300px')" />
            </Tooltip>
          </div>

          <!-- <div class="d-flex">
            <ts-input v-tooltip="$t('promotion.search')" v-model="search" :placeholder="$t('search')"
              style="width: 250px" class="inline-block" />
          </div> -->
        </div>
      </ts-card-wrapper>
      <Table :columns="columns" :data="groupResources" :span-method="handleSpan" row-key="index" size="small"
        :loading="loading" highlight-row stripe max-height="700">
        <template #action="{ row, index }">
          <a href="#" class="text-primary" @click.prevent="edit(row)" v-tooltip="$t('edit')">
            <Icon type="ios-create" size="20" />
          </a>
        </template>
      </Table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'
import iTable from '@/store/i-table-helper'

export default {
  name: 'promotion',
  data() {
    return {
      loading: false,
      width: 'width: 300px'
    }
  },
  computed: {
    ...mapState('promotion/resource', ['resources', 'pagination']),
    groupResources() {
      return iTable.rowGroup(this.resources, 'promo_type')
    },
    search: {
      get() {
        return this.$store.state.promotion.resource.search
      },
      set(newValue) {
        this.$store.commit('promotion/resource/SET_SEARCH', newValue)
        this.$store.commit('promotion/resource/RESET_CURRENT_PAGE')
      },
    },
    start_date: {
      get() {
        return this.$store.state.promotion.resource.startDate
      },
      set(newValue) {
        this.$store.commit('promotion/resource/SET_DATE_START', newValue)
      },
    },
    dateRange: {
      get() {
        return this.$store.state.promotion.resource.dateRange
      },
      set(newValue) {
        this.$store.commit('promotion/resource/SET_DATE_RANGE', newValue)
      },
    },
    columns() {
      return [
        {
          key: 'column_name',
          tree: true,
          maxWidth: 15
        },
        {
          title: this.$t('promotion.eventName'),
          key: 'promotion_name',
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t('promotion.startDate'),
          key: 'promo_start_date',
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t('promotion.endDate'),
          key: 'promo_end_date',
          minWidth: 150,
          sortable: true
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 120
        }
      ]
    },
  },
  methods: {
    moment,
    handleSpan({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    },
    addNew() {
      this.$router.push({ name: 'promotion-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('promotion/resource/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      var name_tem = 'discount-edit'
      switch (record.promo_type_id) {
        case 1:
          name_tem = 'discount-edit'
          break
        case 2:
          name_tem = 'free-item-per-amount-edit'
          break
        case 3:
          name_tem = 'free-coin-edit'
          break
        case 4:
          name_tem = 'buy-item-free-item-edit'
          break
        case 5:
          name_tem = 'incentive-by-item-edit'
          break
        case 6:
          name_tem = 'incentive-by-amount-edit'
          break
      }
      this.$router.push({
        name: name_tem,
        params: {
          id: record.promotion_id,
        },
      })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('promotion/resource/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
<style>
.ivu-table-cell-tree {
  margin-right: 10px;
}

.ivu-table-small i {
  font-size: 14px;
}

.ant-input {
  height: 34px !important;
}

.btn {
  height: 33px !important;
}
</style>